import {emptySplitApi, providesTagsList, queryStarted} from "./api";

export const kpiApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        listKpis: builder.query({
            query: () => ({
                url: 'kpi/list/kpis',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('KPI', result)
        }),
        listKpiTargets: builder.query({
            query: () => ({
                url: 'kpi/list/kpi-targets',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('KPITarget', result)
        }),
        getKpiTarget: builder.query({
            query: (id) => `kpi/kpi-target/${id}`,
            providesTags: (result, error, id) => [{ type: 'KPITarget', id }]
        }),
        createKpiTarget: builder.mutation({
            query: (data) => ({
                url: 'kpi/create/kpi-target',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'KPITarget', id: 'LIST' }]
        }),
        updateKpiTarget: builder.mutation({
            query: ({id, ...data}) => ({
                url: `kpi/update/kpi-target/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getKpiTarget'),
            invalidatesTags: (result, error, { id }) => [{ type: 'KPITarget', id }]
        }),
        deleteKpiTarget: builder.mutation({
            query: (id) => ({
                url: `kpi/delete/kpi-target/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'KPITarget', id: 'LIST' }, { type: 'KPITask', id: 'LIST' }]
        }),
        listKpiTasks: builder.query({
            query: () => ({
                url: 'kpi/task/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('KPITask', result)
        }),
        getKpiTask: builder.query({
            query: (id) => `kpi/task/${id}`,
            providesTags: (result, error, id) => [{ type: 'KPITask', id }]
        }),
        createKpiTask: builder.mutation({
            query: (data) => ({
                url: 'kpi/task/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'KPITask', id: 'LIST' }]
        }),
        updateKpiTask: builder.mutation({
            query: ({id, ...data}) => ({
                url: `kpi/task/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getKpiTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'KPITask', id }]
        }),
        deleteKpiTask: builder.mutation({
            query: (id) => ({
                url: `kpi/task/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'KPITask', id: 'LIST' }]
        }),
        updateKpiTaskStatus: builder.mutation({
            query: ({id, ...data}) => ({
                url: `kpi/task/update-status/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getKpiTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'KPITask', id }]
        }),
        updateKpiTaskValue: builder.mutation({
            query: ({id, ...data}) => ({
                url: `kpi/task/update-value/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getKpiTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'KPITask', id }]
        }),
        updateKpiTaskQuestions: builder.mutation({
            query: ({id, ...data}) => ({
                url: `kpi/task/update-question-list/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getKpiTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'KPITask', id }]
        }),
        listKpiValues: builder.query({
            query: () => ({
                url: 'kpi/kpi-values/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('KPIValue', result)
        }),
        getKpiValue: builder.query({
            query: (id) => `kpi/kpi-value-by-target/${id}`,
            providesTags: (result, error, id) => [{ type: 'KPIValue', id }]
        }),
        updateKpiValue: builder.mutation({
            query: ({target, ...data}) => ({
                url: `kpi/update/kpi-value/${target}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getKpiValue'),
            invalidatesTags: (result, error, { target }) => [{ type: 'KPIValue', target }]
        })
    })
});

export const {
    useListKpisQuery,
    useListKpiTargetsQuery,
    useLazyListKpiTargetsQuery,
    useGetKpiTargetQuery,
    useCreateKpiTargetMutation,
    useUpdateKpiTargetMutation,
    useDeleteKpiTargetMutation,
    useListKpiTasksQuery,
    useGetKpiTaskQuery,
    useCreateKpiTaskMutation,
    useUpdateKpiTaskMutation,
    useDeleteKpiTaskMutation,
    useUpdateKpiTaskStatusMutation,
    useUpdateKpiTaskValueMutation,
    useUpdateKpiTaskQuestionsMutation,
    useListKpiValuesQuery,
    useGetKpiValueQuery,
    useUpdateKpiValueMutation
} = kpiApi;
